import React from "react";
import { useLocation, useHistory } from "react-router-dom";
import { Formik } from "formik";
import styles from "./BusinessProfileModal.module.scss";
import Footer from "../../../components/Footer";
import ImageUploaderV4 from "../../Inputs/ImageUploaderV4";
import Button from "../../Button";
import logo from "../../../static/icons/spin-v2.svg";
import bluecheck from "../../../static/icons/bluecheck.svg";
import routes from "../../../routes";

const SubmittedPerfectly = ({ }) => {
  const location = useLocation();
  const history = useHistory();
  const companyData = location?.state?.companyData;
  if (companyData) {
    // eslint-disable-next-line no-console
    console.log("SubmittedPerfectly companyData:", companyData);
  }

  const coverUrl = companyData?.cover_photo?.url || companyData?.cover_image || null;
  const profileUrl = companyData?.image?.url || companyData?.profile_logo || null;
  const username = companyData?.slug || companyData?.user_name || companyData?.name || companyData?.brand?.designer_name || "";
  const city = companyData?.city;

  const getCityText = (value) => {
    if (!value) return "";
    if (typeof value === "string") return value;
    if (typeof value === "object") {
      if (value.label) return value.label;
      if (value.name && value.country && typeof value.country === "object" && value.country.name) return `${value.name}, ${value.country.name}`;
      if (value.name) return value.name;
      if (value.city) return value.city;
      if (value.text) return value.text;
      if (value.name && value.country) return `${value.name}, ${value.country}`;
    }
    return "";
  };

  const onBack = () => history.goBack();

  return (
    <Formik initialValues={{ label: null, profile: null }} onSubmit={() => {}}>
      {() => (
        <div className={styles.businessForm}>
          <button className={styles.backArrow} onClick={onBack} aria-label="Back" type="button">
            <svg width="26" height="18" viewBox="0 0 26 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.60547 1L1.00043 9" stroke="#0A0B0C" strokeLinecap="round"/>
              <path d="M1 9L9.60504 17" stroke="#0A0B0C" strokeLinecap="round"/>
              <path d="M1 9L24.6639 9" stroke="black" strokeLinecap="round"/>
            </svg>
          </button>
          <div className={styles.submittedContainer}>
            <div>
              <img src={logo} alt="logo" />
            </div>
            <div className={styles.firstStepText}>
              SUBMITTED PERFECTLY
            </div>
            <div className={styles.subHeaderText}>
              Thank you for submitting your business account. It’s now under review. You’ll hear from our team soon with next steps.
            </div>

            <div className={styles.submittedForm}>
              <div className={styles.imageUploaderStepOneRectangular}>
                <ImageUploaderV4
                  name="label"
                  placeholder={coverUrl ? "" : "Upload cover picture"}
                  top="true"
                  isRectangular={true}
                  preview={coverUrl}
                />
              </div>
              <div className={`${styles.imageUploaderStepOne} ${styles.overlapHalf}`}>
                <ImageUploaderV4
                  name="profile"
                  top="true"
                  profile_logo="true"
                  placeholder={profileUrl ? "" : "Upload profile picture"}
                  preview={profileUrl}
                />
              </div>

              <div className={styles.firstStageContainer}>
                <div className={styles.usernameRow}>
                  <div className={styles.username}>{username ? `@${username}` : "here businessuername blucheck"}</div>
                  <img src={bluecheck} alt="verified" className={styles.bluecheckIcon} />
                </div>
                <div className={styles.city}>{getCityText(city) || "here city"}</div>

                <Button className={styles.button} size="large" color="black" type="button" onClick={()=>{
                  history.push(routes.prelogin)
                }}>
                  OK
                </Button>
              </div>
            </div>
          </div>

          <Footer className={styles.footer} />
        </div>
      )}
    </Formik>
  );
};

export default SubmittedPerfectly;


